'use strict';

import * as Onyx from '../lib/onyx.min.js';
import { default as MatterJSEntity } from './base-matter';

const COLLISION_CATEGORY = 0x0004;
const COLLISION_MASK = 0x0001 | 0x0008 | 0x0004; // GROUND | MOUSE | SELF

const COLLISION_TOLERANCE = 100.5;

export default class Barrel extends MatterJSEntity {
    constructor(position = [0,0], scale = 1, rotation = 0, { matterEngine = null } = {}){
        super(matterEngine, position, [1, 1], rotation, Matter.Bodies.circle(position[0], -position[1], scale * 45, { density: 0.001, gravityScale: 0, friction: 0.5 }));

        let modelRNG = (Math.random() * 3 | 0) + 1;
        let modelName = "barrel0" + modelRNG;
           
        // this.body.collisionFilter.category = COLLISION_CATEGORY;
        // this.body.collisionFilter.mask = COLLISION_MASK;

        // new Onyx.ImportSpriteFromTexturePacker("res/sprites/takotsuboBreak-0.json", {pixelated: true, defaultAnimation: "takotsuboBreak-0", speed: 1000 / 15, autoplay: false}).then((sprite) => {
            // this.addComponent(sprite);
            // this.transform.scaleTo(0.25, 0.25);
        Onyx.ImportModelFromOBJ.load({src: "res/models/" + modelName + ".obj"}).then((model) => {
            this.addComponent(model);

            this.components[0].meshes[0].material.ambientTexture = this.parentScene.caustic;
            this.components[0].meshes[0].material.buildProgram();

            this.components[0].transform.rotateX(Math.PI / 2);
            this.transform.scaleTo(8, 8, 8);
            // this.components[0].transform.rotateY(Math.random() * Math.PI);
            // console.log(sprite);
        });
    }

    @Onyx.handles("oncollide")
    oncollide(event){
        if(event.relativeMomentum >= COLLISION_TOLERANCE){
            this.parentScene.shakeCamera();

            if(this.canPlaySound) game.sfx['impactsplat03'].play();
            this.canPlaySound = false;

            this.parentScene.setTimeout(() => {
                this.canPlaySound = true;
            }, 250);
        }
    }
}